module.exports = __webpack_public_path__ + "img/weibo_avatar.7cba5ee1.png";